import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//样式normalize
import 'style/border.css';
import 'style/reset.css';
//公共样式
// import 'style/index.css'
import 'style/index.scss'
import './assets/iconfont/iconfont.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Loading } from 'element-ui';
Vue.prototype.$loading = Loading;
import moment from 'moment';

import lodash from 'lodash'
Vue.prototype.$lodash = lodash;

import md5 from 'js-md5'

import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

import Cookies from 'js-cookie';
Vue.prototype.Cookies = Cookies;

import { Message, MessageBox } from 'element-ui';
Vue.prototype.$message = Message;

Vue.config.productionTip = false;
Vue.use(ElementUI);

Vue.prototype.$moment = moment;
Vue.prototype.$md5 = md5;

// import PDF from 'vue-pdf'
// Vue.component('PDF', PDF);

// import 'common/js/permission.js'
// const routesList = [
//   {
//     path: '/',
//     name: 'Home',
//     redirect: '/UC'
//   }, {
//     path: '/UC',
//     name: 'UserIndex',
//     component: () => import(/* webpackChunkName: "about" */ '@/views/User'),
//     redirect: '/UC/User',
//     children: [{
//       path: 'User',
//       name: 'User',
//       component: () => import(/* webpackChunkName: "User" */ '@/views/User/User')
//     }, {
//       path: 'Center',
//       name: 'Center',
//       component: () => import(/* webpackChunkName: "User" */ '@/views/User/Center'),
//       redirect: '/UC/Center/UserCenter',
//       meta: {
//         name: '个人中心',
//         path: "/UC/Center/UserCenter"
//       },
//       children: [{
//         path: 'UserCenter',
//         name: 'UserCenter',
//         component: () => import(/* webpackChunkName: "User" */ '@/views/User/UserCenter')
//       }, {
//         path: 'CenterEdit',
//         name: 'CenterEdit',
//         component: () => import(/* webpackChunkName: "User" */ '@/views/User/CenterEdit'),
//         meta: {
//           name: '编辑资料'
//         }
//       }, {
//         path: 'PsdEdit',
//         name: 'PsdEdit',
//         component: () => import(/* webpackChunkName: "User" */ '@/views/User/PsdEdit'),
//         meta: {
//           name: '修改密码'
//         },
//       }]
//     }, {
//       path: 'InfoCenter',
//       name: 'InfoCenter',
//       component: () => import(/* webpackChunkName: "User" */ '@/views/User/InfoCenter'),
//       meta: {
//         name: '消息中心',
//         path: "/Center/UserCenter"
//       },
//     }]
//   }];

// router.addRoutes(routesList)
// // router.push({ path: '/UC/Center/UserCenter' })
// console.log("TCL: router", router)














router.beforeEach((to, from, next) => {
  const code = Cookies.get("identifyCode");
  if (to.path.includes("Homepage")) {
    next();
  } else {

    if (!Cookies.get('identifyCode')) {
      // router.push('/Login');
      if (to.path.includes('Login'))
        next();
      else
        next('/Login/Login');
      return;
    }
  }
  if (from.path == '/' && to.path == '/') {
    if (code && code.slice(0, 2) == "WR") {
      if (to.path.includes('/ReportPlatform'))
        next();
      else
        next('/ReportPlatform/ReportList');
    } else {
      if (to.path.includes('/UC'))
        next();
      else
        next('/UC');
    }
  }

  if (code) {
    const type = code.slice(0, 2);

    // if (type == "WR") {
    //   console.log(to.meta,'to.meta--->0okm')
    //   if (!to.meta.type) {
    //     console.log(to.meta.type,'123')
    //     MessageBox.confirm('对不起,暂无相关权限,联系管理员或重新登录?', '提示', {
    //       confirmButtonText: '重新登录',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       const code = Cookies.get("identifyCode");
    //       let loginPath = "/Login";
    //       if (code && code.slice(0, 2) == "WR") loginPath = "/ReportLogin";

    //       Cookies.remove("legalName");
    //       Cookies.remove("institutionName");
    //       Cookies.remove("identifyCode");
    //       Cookies.remove("riskToken");
    //       if (to.path.includes('Login'))
    //         next();
    //       else
    //         next(loginPath);
    //       return;
    //     }).catch(() => {

    //     });
    //     return
    //   }
    // }
  }

  next();
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


